import { useEffect, useState } from 'react';

import { useDayJs } from '@common/hooks';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export const useCountdownTimer = (end_at?: number) => {
  let interval: NodeJS.Timeout | null = null;
  const dayjs = useDayJs();
  const end_date = dayjs(end_at);
  const now = dayjs();
  const [distance, setDistance] = useState(end_date.diff(now));
  const countdown = getCountdown(distance);
  const is_ended = distance <= 0;

  function getCountdown(distance: number) {
    return {
      days: Math.floor(distance / DAY),
      hours: Math.floor((distance % DAY) / HOUR),
      minutes: Math.floor((distance % HOUR) / MINUTE),
      seconds: Math.floor((distance % MINUTE) / SECOND),
    };
  }

  useEffect(() => {
    if (!interval) {
      interval = setInterval(() => {
        if (distance <= SECOND && interval) {
          clearInterval(interval);
        }

        setDistance((distance) => distance - SECOND);
      }, SECOND);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [is_ended]);

  return {
    countdown,
    is_ended,
  };
};
